// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as PullDown$Showside from "../utils/PullDown.bs.js";
import * as Transition$Showside from "../utils/Transition.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as QuickViewButton$Showside from "./QuickViewButton.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as PausePageScrolling$Showside from "./PausePageScrolling.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function PullDownModal(Props) {
  var children = Props.children;
  var isOpen = Props.isOpen;
  var onClose = Props.onClose;
  var learnMoreLink = Props.learnMoreLink;
  var label = Props.label;
  var showHeaderOpt = Props.showHeader;
  var fullWidthOpt = Props.fullWidth;
  var unmountOpt = Props.unmount;
  var pullDownTargetOpt = Props.pullDownTarget;
  var zIndex = Props.zIndex;
  var dataId = Props.dataId;
  var dataTestId = Props.dataTestId;
  var showHeader = showHeaderOpt !== undefined ? showHeaderOpt : true;
  var fullWidth = fullWidthOpt !== undefined ? fullWidthOpt : false;
  var unmount = unmountOpt !== undefined ? unmountOpt : true;
  var pullDownTarget = pullDownTargetOpt !== undefined ? pullDownTargetOpt : "header";
  ConfigurationProvider$Showside.use(undefined);
  var match = ViewportContext$Showside.use(undefined);
  var breakpoint = match.breakpoint;
  var renderCloseButton = function (param) {
    return React.createElement(QuickViewButton$Showside.make, {
      className: CSS$Showside.prefix(Cn.make(["w-12 h-12 flex flex-shrink-0 items-center justify-center hover:opacity-90 pointer-events-auto", showHeader ? "text-primary" : "m-2 bg-white rounded-full text-black"])),
      onClick: function (param) {
        Curry._1(onClose, undefined);
      },
      children: React.createElement(Unicons$Showside.UilTimes.make, {}),
      dataTestId: "modal-button-close"
    });
  };
  var renderLearnMore = function (param) {
    if (learnMoreLink !== undefined) {
      return React.createElement(Link$Showside.make, {
        children: null,
        href: learnMoreLink,
        unstyled: true,
        className: CSS$Showside.prefix("text-accent font-medium text-base flex items-center space-x-1"),
        openLinkInNewTab: true
      }, React.createElement("div", undefined, "Learn More"), React.createElement(Unicons$Showside.UilExternalLinkAlt.make, {
        size: /* Px */{
          _0: 14
        }
      }));
    } else {
      return null;
    }
  };
  var stopScrollPropagation = function (contentOpt, e) {
    var content = contentOpt !== undefined ? contentOpt : false;
    if (content && pullDownTarget === "modal") {
      return;
    } else {
      e.stopPropagation();
      return;
    }
  };
  var stopTouchPropagation = function (contentOpt, e) {
    var content = contentOpt !== undefined ? contentOpt : false;
    if (content && pullDownTarget === "modal") {
      return;
    } else {
      e.stopPropagation();
      return;
    }
  };
  var alignmentCn = breakpoint >= 2 ? "items-center justify-center" : "items-end";
  var roundedCn = breakpoint >= 2 ? "rounded-md" : "rounded-t-xl";
  var paddingCn = breakpoint >= 2 ? "p-6" : "";
  var widthCn = fullWidth ? "w-full" : "";
  var enter = CSS$Showside.prefix(breakpoint >= 2 ? "transiton-opacity duration-200" : "transiton-transform transform ease-out-bounce duration-300");
  var leave = CSS$Showside.prefix(breakpoint >= 2 ? "transiton-opacity duration-100" : "transiton-transform transform ease-out duration-300");
  var enterFrom = CSS$Showside.prefix(breakpoint >= 2 ? "opacity-0" : "translate-y-full");
  var enterTo = CSS$Showside.prefix(breakpoint >= 2 ? "opacity-100" : "translate-y-0");
  var leaveFrom = CSS$Showside.prefix(breakpoint >= 2 ? "opacity-100" : "translate-y-0");
  var leaveTo = CSS$Showside.prefix(breakpoint >= 2 ? "opacity-0" : "translate-y-full");
  var partial_arg = false;
  var partial_arg$1 = false;
  var partial_arg$2 = false;
  var partial_arg$3 = false;
  var tmp = {
    "aria-modal": true,
    className: CSS$Showside.prefix(Cn.make(["fixed bottom-0 left-0 w-full h-full overflow-hidden flex", alignmentCn, isOpen ? "" : "pointer-events-none", zIndex !== undefined ? "" : "z-max"])),
    onTouchEnd: function (param) {
      return stopTouchPropagation(partial_arg, param);
    },
    onTouchMove: function (param) {
      return stopTouchPropagation(partial_arg$1, param);
    },
    onTouchStart: function (param) {
      return stopTouchPropagation(partial_arg$2, param);
    },
    onScroll: function (param) {
      return stopScrollPropagation(partial_arg$3, param);
    }
  };
  if (label !== undefined) {
    tmp["aria-label"] = Caml_option.valFromOption(label);
  }
  var tmp$1 = zIndex !== undefined ? {
    zIndex: String(zIndex)
  } : undefined;
  if (tmp$1 !== undefined) {
    tmp.style = Caml_option.valFromOption(tmp$1);
  }
  var partial_arg$4 = true;
  var partial_arg$5 = true;
  var partial_arg$6 = true;
  var partial_arg$7 = true;
  var tmp$2 = {
    children: React.createElement("div", tmp, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["bg-black bg-opacity-50 absolute inset-0 transiton-opacity duration-300", isOpen ? "opacity-100" : "opacity-0"])),
      onClick: function (param) {
        Curry._1(onClose, undefined);
      }
    }), React.createElement(PullDown$Showside.make, {
      onPullDown: function (param) {
        Curry._1(onClose, undefined);
      },
      className: CSS$Showside.prefix(Cn.make(["flex flex-col justify-end pointer-events-none", paddingCn, alignmentCn])),
      children: null
    }, !showHeader && isOpen ? renderCloseButton(undefined) : null, React.createElement(Transition$Showside.make, {
      show: isOpen,
      unmount: unmount,
      enter: enter,
      enterFrom: enterFrom,
      enterTo: enterTo,
      leave: leave,
      leaveFrom: leaveFrom,
      leaveTo: leaveTo,
      className: CSS$Showside.prefix(Cn.make(["max-h-full bg-main shadow-xl flex flex-col overflow-hidden pointer-events-auto", widthCn, roundedCn])),
      children: null,
      style: {
        maxWidth: "1366px"
      },
      dataTestId: "pull-down-modal"
    }, isOpen ? React.createElement(PausePageScrolling$Showside.make, {}) : null, React.createElement("div", {
      className: CSS$Showside.prefix("py-2 px-4 flex items-center space-x-2")
    }, showHeader ? React.createElement(React.Fragment, undefined, React.createElement("div", {
      className: CSS$Showside.prefix("text-xl flex-grow font-semibold text-primary")
    }, Belt_Option.getWithDefault(label, "")), React.createElement("div", {
      className: CSS$Showside.prefix("flex-shrink-0")
    }, renderLearnMore(undefined)), React.createElement("div", {
      className: CSS$Showside.prefix("flex-shrink-0")
    }, renderCloseButton(undefined))) : null), React.createElement("div", {
      className: CSS$Showside.prefix("overflow-x-hidden overflow-y-auto flex-grow relative leading-0 text-primary"),
      onTouchEnd: function (param) {
        return stopTouchPropagation(partial_arg$4, param);
      },
      onTouchMove: function (param) {
        return stopTouchPropagation(partial_arg$5, param);
      },
      onTouchStart: function (param) {
        return stopTouchPropagation(partial_arg$6, param);
      },
      onScroll: function (param) {
        return stopScrollPropagation(partial_arg$7, param);
      }
    }, children))))
  };
  if (dataTestId !== undefined) {
    tmp$2.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataId !== undefined) {
    tmp$2.dataId = dataId;
  }
  return React.createElement(BaseWithTheme$Showside.make, {
    initiator: "pulldown-modal",
    portal: true,
    children: React.createElement(DataAttribute$Showside.make, tmp$2)
  });
}
PullDownModal.displayName = "PullDownModal";
var make = PullDownModal;
export { make };
/* react Not a pure module */